import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'sp-navigation-link',
  templateUrl: './navigation-link.component.html',
  styleUrls: ['./navigation-link.component.scss'],
})
export class NavigationLinkComponent {
  @Input() navLinks: {
    path: string;
    label: string;
    alternateLabel?: string;
  }[] = [];
  @Output() selectedTab = new EventEmitter<string>();

  currentTab = '';

  getCurrentTab(path: string) {
    this.selectedTab.emit(path);
  }
}
